export const FETCH_CALL_HANDLING = "FETCH_CALL_HANDLING";
export const FETCH_CALL_HANDLING_SUCCESS = "FETCH_CALL_HANDLING_SUCCESS";

export const FETCH_QUEUE_WAIT_TIME = "FETCH_QUEUE_WAIT_TIME";
export const FETCH_QUEUE_WAIT_TIME_SUCCESS = "FETCH_QUEUE_WAIT_TIME_SUCCESS";

export const SET_QUEUES_DETAILS = "SET_QUEUES_DETAILS";
export const SET_QUEUE_INFO = "SET_QUEUE_INFO";

export const SET_QUEUE_TABLE_FILTERS = "SET_QUEUE_TABLE_FILTERS";
export const CLEAR_QUEUE_TABLE_FILTERS = "CLEAR_QUEUE_TABLE_FILTERS";

export const APPLY_QUEUE_TABLE_FILTERS = "APPLY_QUEUE_TABLE_FILTERS";
export const CLEAR_APPLIED_QUEUE_TABLE_FILTERS =
  "CLEAR_APPLIED_QUEUE_TABLE_FILTERS";

export const SELECTED_QUEUE_VIEW = "SELECTED_QUEUE_VIEW";

export const setQueuesDetails = (payload) => ({
  type: SET_QUEUES_DETAILS,
  payload,
});

export const setQueueInfo = (payload) => ({
  type: SET_QUEUE_INFO,
  payload,
});

export const fetchCallHandling = (payload) => ({
  type: FETCH_CALL_HANDLING,
  payload,
});
export const fetchCallHandlingSuccess = (payload) => ({
  type: FETCH_CALL_HANDLING_SUCCESS,
  payload,
});

export const fetchQueueWaitTime = (payload) => ({
  type: FETCH_QUEUE_WAIT_TIME,
  payload,
});
export const fetchQueueWaitTimeSuccess = (payload) => ({
  type: FETCH_QUEUE_WAIT_TIME_SUCCESS,
  payload,
});

export const setQueueTableFilters = (payload) => ({
  type: SET_QUEUE_TABLE_FILTERS,
  payload,
});
export const clearQueueTableFilters = (payload) => ({
  type: CLEAR_QUEUE_TABLE_FILTERS,
  payload,
});

export const applyQueueTableFilters = (payload) => ({
  type: APPLY_QUEUE_TABLE_FILTERS,
  payload,
});
export const clearAppliedQueueTableFilters = (payload) => ({
  type: CLEAR_APPLIED_QUEUE_TABLE_FILTERS,
  payload,
});

export const selectedQueueView = (payload) => ({
  type: SELECTED_QUEUE_VIEW,
  payload,
});
